export const isObjectEmpty = (value?: unknown): boolean =>
  value === undefined || value === null || Object.keys(value).length === 0

export const shallowEqual = (
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
  keys?: string[]
): boolean =>
  Array.isArray(keys)
    ? keys.find((key) => obj1[key] !== obj2[key]) === undefined
    : Object.keys(obj1).find((key) => obj1[key] !== obj2[key]) === undefined &&
      Object.keys(obj2).find((key) => obj1[key] !== obj2[key]) === undefined

export const safeDeepUpdate = (
  obj: Record<string, unknown>,
  path = [],
  value: unknown
): Record<string, unknown> => {
  if (
    obj === undefined ||
    obj === null ||
    path === undefined ||
    path === null ||
    path.length === 0
  ) {
    return
  }
  const lastKey = path.pop()
  const loc = path.reduce((acc, cur) => {
    if (acc[cur] === undefined || acc[cur] === null) {
      acc[cur] = {}
    }
    return acc[cur]
  }, obj)
  loc[lastKey] = typeof value === 'function' ? value(loc[lastKey]) : value
}

export const extract = (object: Record<string, unknown>, props = []): Record<string, unknown> => {
  const results = {}
  props.forEach(prop => {
    if (object[prop] !== undefined) {
      results[prop] = object[prop]
    }
  })
  return results
}
